import { environment } from "../config/environment";
import { postToBackendAPI } from "./api.service";

export interface JobTemplateApplyResult {
  documentsCreated: number;
  documentsSkipped: number;
  statusItemsCreated: number;
  createdNames: string[];
}

const baseUrl = () =>
  `${environment.api.baseUrl}${environment.api.endpoints.jobTemplates}`;

/**
 * Apply the "Annuals" job template to a workbook. Backend creates the standard
 * set of 8 placeholder client documents plus 7 doc-linked status items. Existing
 * placeholders with the same name are skipped (idempotent).
 */
export async function applyAnnualsTemplate(
  spreadsheetId: string
): Promise<JobTemplateApplyResult> {
  return await postToBackendAPI<JobTemplateApplyResult>(
    `${baseUrl()}/spreadsheet/${spreadsheetId}/annuals`,
    {}
  );
}
